import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';
import useIntlMessage from '@app/hooks/use-intl-message';
import './LabeledToggle.scss';

const LabeledToggle = ({ onChange, options: [firstOption, secondOption], small, checked }) => {
  const groupName = `labeled-toggle-${firstOption}-${secondOption}`;
  const [firstOptionAriaLabel, secondOptionAriaLabel] = useIntlMessage(
    `qau-${firstOption}-toggle-aria-label`,
    `qau-${secondOption}-toggle-aria-label`,
  );

  return (
    <div className={classnames('labeled-toggle', { small })} data-testid="labeled-toggle" role="radiogroup" tabIndex={0}>
      <label htmlFor={`firstOption-${firstOption}`} className="label" id={`label-firstOption-${firstOption}`}>
        <input
          id={`firstOption-${firstOption}`}
          type="radio"
          name={groupName}
          value={firstOption}
          onChange={onChange}
          checked={checked === firstOption}
          aria-label={firstOptionAriaLabel}
          aria-checked={checked === firstOption}
        />
        <span aria-hidden="true">
          <LocalizedText id={`qau-${firstOption}-toggle-label-text`} />
        </span>
      </label>
      <label htmlFor={`secondOption-${secondOption}`} className="label" id={`label-secondOption-${secondOption}`}>
        <input
          id={`secondOption-${secondOption}`}
          type="radio"
          name={groupName}
          value={secondOption}
          onChange={onChange}
          checked={checked === secondOption}
          aria-label={secondOptionAriaLabel}
          aria-checked={checked === secondOption}
        />
        <span aria-hidden="true">
          <LocalizedText id={`qau-${secondOption}-toggle-label-text`} />
        </span>
      </label>
    </div>
  );
};

LabeledToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  checked: PropTypes.string.isRequired,
  small: PropTypes.bool,
};

export default LabeledToggle;
